import { useTranslations } from 'next-intl'

import { Floor } from '@/entities/map'
import { useMultiScrollState } from '@/shared/lib'

import { Filter, useFilter } from '../../model/filter'
import { Title, List, Item } from '../common/layout'

const useFloors = () => {
  const t = useTranslations('filter')

  const FLOORS = [
    {
      title: t('floor_basement'),
      value: Floor.SEMI_BASEMENT,
    },
    {
      title: t('floor_first'),
      value: Floor.FIRST_FLOOR,
    },
    {
      title: t('floor_two_to_nine'),
      value: Floor.FROM_SECOND_TO_NINE,
    },
    {
      title: t('floor_ten_or_more'),
      value: Floor.OVER_TEN,
    },
  ]

  return { FLOORS }
}

type Props = {
  className?: string
}

export const Floors = ({ className }: Props) => {
  const t = useTranslations('filter')

  const { registerScrollElement } = useMultiScrollState<HTMLDivElement>()

  const {
    type,
    filter: { floors },
    updateFilter,
  } = useFilter()

  const { FLOORS } = useFloors()

  const handleFloorChange = (value: Floor) => () => {
    updateFilter({ floors: value })
  }

  return (
    <div
      className={className}
      ref={element => {
        if (element) {
          registerScrollElement(Filter.Floors, element)
        }
      }}
    >
      <Title>{t('floor.title')}</Title>
      <List>
        {FLOORS.map(({ title, value }) => (
          <Item
            key={value}
            type={type}
            selected={floors.includes(value)}
            onClick={handleFloorChange(value)}
          >
            {title}
          </Item>
        ))}
      </List>
    </div>
  )
}
